import styled from "styled-components";

export const MetaFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ theme }) => theme.aboveBreakpoint} {
    flex-direction: row;

    & > .MuiFormControl-root {
      flex: 1;
    }
  }
`;

export const InfoBox = styled.div`
  padding: 16px 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.redesign.db20};
  }
`;
